// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import { createFileRoute, redirect } from "@tanstack/react-router";

// Sprint 44: Family merged under People (organization) — this path stays for
// bookmarks and mobile deep links.
export const Route = createFileRoute("/_app/_auth/dashboard/family")({
	beforeLoad: () => {
		throw redirect({
			to: "/dashboard/organization",
			search: { tab: "family" },
			replace: true,
		});
	},
});
